<template>
    <div class="">
        <template v-if="canEdit">
            <el-select v-model="vo[model]" :placeholder="$tx('hygl.components.selectYear', '请选择年份')">
                <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item" />
            </el-select>
        </template>
        <div v-else>{{ vo.planYear }}</div>
    </div>
</template>

<script>
export default {
    name: 'SelectYear',
    components: {},
    props: {
        vo: {
            type: Object,
            default() {
                return {}
            }
        },
        model: { type: String, default: 'year' },
        canEdit: { type: Number, default: 1 },
        required: { type: Boolean, default: false }
    },
    data() {
        return {
            yearOptions: []
        }
    },
    created() {
        this.currentYear()
    },
    methods: {
        // 当前年份
        currentYear() {
            const year = new Date().getFullYear()
            this.yearOptions.push(year)
            this.yearOptions.push(year + 1)
        }
    }
}
</script>

<style scoped lang="scss"></style>
